import { Chip, Divider, FormControl, IconButton, Typography, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import classNames from 'classnames';
import React from 'react';
import { MdClose, MdSearch } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import LookupDialog from './LookupDialog';
import * as Actions from './Store/Actions/LookupActions';
import LookupReducer from './Store/Reducers/LookupReducer';

const styles = theme => ({
    root: {
        padding: '5px 4px',
        display: 'flex',
        alignItems: 'center',
        height: '57px',
        border: '1px solid ' + theme.palette.divider,
    },
    input: {
        marginLeft: 8,
        flex: 1,
        minHeight: "4.6rem"
    },
    iconButton: {
        paddingLeft: 10,
    },
    divider: {
        width: 1,
        height: 'auto',
        margin: 0,
    },
    layoutRoot: {},
    rootTheme: {
        color: theme.palette.text.primary,
        //    backgroundColor:  theme.palette.background.paper, //default
    },
    formControl: {
        margin: '0px 0',
        paddingTop: '8px',
        width: '100%',
        '&:last-child': {
            marginBottom: 0
        }
    },
    group: {},
    formGroupTitle: {
        position: 'absolute',
        top: -10,
        left: 8,
        fontWeight: 600,
        padding: '0 4px',
        backgroundColor: theme.palette.type === 'dark' ? '#424242' : '#FFF',
        fontSize: '12px',
    },
    formGroup: {
        position: 'relative',
        maxHeight: '58px',
        border: '1px solid ' + theme.palette.divider,
        borderRadius: 2,
    },
    chip: {
        marginTop: '4px'
    }
});

class LookupApp_old extends XAPPComponent {

    handleLookupRemove = (ev) => {
        ev.stopPropagation()
        if (this.props.campoid) {
            this.props.onChange(null, this.props.campoid);
        }
        else {
            this.props.onChange();
        }
    };

    render() {
        const { classes, required, openDialog, instancia = null, selected, id, registro, campoid, campolabel, mainClass, className, state, label, onChange, readOnly, multiSelect = false } = this.props;

        return (
            <React.Fragment>
                <div className={classNames(className, classes.formGroup, "flex flex-row rounded-6")}>
                    <Typography className={classes.formGroupTitle} color="textSecondary">{label + (required ? " *" : "")}</Typography>
                    <FormControl component="span" className={classes.formControl} key={id + "_Paper"} name={id + "_Paper"}>
                        <div className={"flex flex-row"}>
                            <div className={classNames(classes.input, "flex")}>
                                {selected && selected.map(data => {
                                    if (readOnly) {
                                        return (
                                            <Chip
                                                key={data.id}
                                                label={data.label}
                                                size="medium"
                                                className={classes.chip}

                                            />
                                        );
                                    }
                                    else {
                                        return (
                                            <Chip
                                                key={data.id}
                                                label={data.label}
                                                size="medium"
                                                onDelete={(event) => this.handleLookupRemove(event)}
                                                className={classes.chip}

                                            />
                                        );
                                    }
                                })}
                            </div>
                            <div className="flex">
                                {!readOnly &&
                                    <IconButton
                                        className={classes.iconButton}
                                        aria-label="Excluir"
                                        onClick={this.handleLookupRemove}
                                        key={id + "_Excluir"}
                                    >
                                        <MdClose />
                                    </IconButton>
                                }
                                <Divider className={classes.divider} />
                                {!readOnly &&
                                    <IconButton
                                        className={classes.iconButton}
                                        aria-label="Pesquisar"
                                        onClick={() => { openDialog(id + "_LookupDialog") }}
                                        key={id + "_Pesquisar"}
                                    >
                                        <MdSearch />
                                    </IconButton>
                                }
                            </div>
                        </div>
                    </FormControl>
                </div>

                <LookupDialog
                    instancia={instancia}
                    mainClass={mainClass}
                    LookupApp={this}
                    key={id + "_LookupDialog"}
                    id={id + "_LookupDialog"}
                    campoid={campoid}
                    campolabel={campolabel}
                    state={state}
                    registro={registro}
                    onChange={onChange}
                    multiSelect={multiSelect}
                />
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: Actions.openDialog
    }, dispatch);
}

function mapStateToProps({ LookupApp }) {
    return {
        Lookup: LookupApp,
    }
}

export default withReducer('LookupApp', LookupReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(LookupApp_old))));
